import React, { useRef, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';

import {downloadReport} from '../../../actions/backoffice/partners'
import { DateWithModal } from './../../../_common/dateWithModal';
import {ToasterConfigurations} from '../../../constants/toasterText/configurations';
import { toast } from 'react-toastify';

export const ExportPartner = ({ allPartners = [] }) => {
	const formRef = useRef();
	const defaultPartnerId = '00000000-0000-0000-0000-000000000000';
	const [exportParameters, setExportParameters] = useState({partnerId: defaultPartnerId, fromDate: undefined, toDate: undefined, isLoading: false});

	const partnerTemp = [{id: defaultPartnerId, name: 'Tous'}, ...[...allPartners].sort((a, b) => a.name.localeCompare(b.name))];
	function getStartDate(date) { setExportParameters({ ...exportParameters, fromDate: date }); }
	function getEndDate(date) { setExportParameters({ ...exportParameters, toDate: date }); }

	return (
		<div className="modal fade px-0" id="ExportPartner" aria-labelledby="ExportPartnerLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert alert-primary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="sr-only visually-hidden">Exporter partenaire</h5>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-primary text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Exporter les données du partenaire</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body py-0">
						<form className="block" noValidate ref={formRef}>
							<div className="block text-left">
								<div className="form-group">
									<label className="h6 font-weight-bolder" htmlFor="email">Partenaire</label>
									<select 
									className="custom-select" id="jours" tabIndex={-98} 
									onChange={(e) => setExportParameters({ ...exportParameters, partnerId: e.target.value })}
									value={exportParameters.partnerId ?? ''}
									>
										{
											!R.isNil(partnerTemp) && partnerTemp.map(partner => (<option key={partner.id} value={partner.id}>{partner.name.toUpperCase()}</option>))
										}
									</select>
									<div className={"invalid-feedback alert alert-danger"}>
										Adresse e-mail invalide
									</div>
								</div>

								<div className="form-group flex-row align-items-center">
									<DateWithModal isRequired={true} classToolbar={true} selectedDate={exportParameters.fromDate} setSelectedDate={(d) => {setExportParameters({ ...exportParameters, fromDate: d})}} />
									<div className="d-inherit mx-2 text-gray">-</div>
									<DateWithModal isRequired={true} classToolbar={true} selectedDate={exportParameters.toDate} setSelectedDate={(d) => setExportParameters({ ...exportParameters, toDate: d})} />
								</div>
								{/* <div className="col col-lg-4 form-group">
									<label className="h6 font-weight-bolder" htmlFor="role">Permission</label>
									<select className="form-control custom-select" id="role" aria-label="Default select example">
										<option selected>Choose permissions...</option>
										<option value="Viewer">Viewer</option>
									</select>
								</div> */}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal" onClick={() => {
							setExportParameters({partnerId: defaultPartnerId, fromDate: null, toDate: null, isLoading: false});
						}}>Annuler</button>
						{
							exportParameters.isLoading ?
								<button className={"btn btn-primary loading-btn show"}>Exporter<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
								:
								<button className={"btn btn-primary"}
									onClick={(e) => {
										e.preventDefault();
										setExportParameters({ ...exportParameters, isLoading: true });
										downloadReport(exportParameters.partnerId, exportParameters.fromDate.toISOString().split('T')[0], exportParameters.toDate.toISOString().split('T')[0])
										.then(() => {
											setExportParameters({ ...exportParameters, isLoading: false });
											$('.modal').modal("hide");
											setExportParameters({partnerId: defaultPartnerId, fromDate: null, toDate: null, isLoading: false});
										})
										.catch(() =>{
											setExportParameters({ ...exportParameters, isLoading: false });
											toast.error(`Erreur lors de la génération du rapport.`, ToasterConfigurations)
										})
									}}>
									Exporter
								</button>
						}
					</div>
				</div>
			</div>
		</div>
	);
};